const listPointsBody = document.querySelector('#newScheduleCellSCardPickerProgram').querySelector('div[name=body]');
// import auth from '../tools/storage.js';

import filmsWithoutMarkup from '../markup2/filmsWithoutProgramms.js';
import tools from '../tools/tools.js';
export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  drawChildDataInContainer(fullArrayData, allFilms, parentID, atrHtml){
    let answer = '';

    if(fullArrayData)
      fullArrayData.forEach((item, index) => {
        if(item.parent === parentID)
          answer =  `<div class="w-100 p-3"> ${this.drawDataInContainerOneBlock(item, fullArrayData,  allFilms, atrHtml, index)}</div>`;
      });

    return answer;

  },
  drawDataInContainerOneBlock(item, fullArrayData, allFilms, atrHtml, index){
    
    // console.log(item);
    let fullHtml = '';
 
     let allTime = 0;
        let blockFilms = '';
        if (item.films) {
            blockFilms = ` <div class="column w-100 p-1 m-3" ${atrHtml}>`;
          for (let i = 0; i < item.films.length; i++) {

            allFilms.forEach((fElement) => {
              // console.log(fElement);
              if(item.films[i].filmIDfk === fElement.id){
                blockFilms += `<small ${atrHtml}>${fElement.name}</small>`;
                allTime += parseInt(fElement.long, 10);
              }
            });
          
          }
          blockFilms += '</div>';
        }

      let value = allTime;

      let lsec = value%(60);
      value -= lsec;
      value = value/60;
      let lmins = value%(60);;
      value -= lmins;
      value = value/60;
      let lhours =value;

      if(lmins < 10)
        lmins = `0${lmins}`;

      if(lsec < 10)
        lsec = `0${lsec}`;

      value = `${lhours}:${lmins}:${lsec}`;




      return `<div class="reference-header  m-0 p-1 "  ${atrHTMl}>

              <div  class="reference-column m-0 p-0"  ${atrHTMl}> 
                <label ${atrHTMl}  class=" p-0 m-0 iconGroupOfConsider">${item.id  }</label>
              </div>  
              <label ${atrHTMl}  class="reference-column m-0 p-0 pl-1">${item.name} </label>
            </div>`;




      let someColor = '';
      if(item.color)
        someColor = `<div class="colorPreview"  style="background-color:#${item.color};" ></div>`;
      let atrHTMl = ` pID=${item.id} pName="${item.name}" `;

      fullHtml += ` <div class = "block_items blockProgramDesk " ${atrHTMl}>
                        <div class="row  m-0 p-3" ${atrHTMl}> 
                          <b class="ml-auto mr-auto txt-al-center" ${atrHTMl}>${item.name} </b>
                        </div>
                       <div class="row  m-0 p-1 pl-3 pr-3 "  ${atrHTMl}> 
                          ${someColor}
                          <div class="ml-3 cloud"  ${atrHTMl}>
                            <img src="https://festcontent.ru/img/long.svg"  ${atrHTMl}>
                            <b  ${atrHTMl}>${value}</b>
                          </div>
     
                        </div>
                        <div name="filmsList" class=" row w-100 m-0 p-0"  ${atrHTMl} >${blockFilms}${this.drawChildDataInContainer(fullArrayData,allFilms,item.id, atrHTMl)}</div>`;


        fullHtml += `</div>`;
    return fullHtml;
  }
  ,
  drawDataInContainer(enterprisesData, fullArrayData, allFilms) {
    this.cleanContainer();
    let oldSection;

    let fullHtml =` <div class="w-100 m-0 p-0">
                      <div class="reference-header firstRow">
                          <div class="reference-column">№</div>
                          <div class="reference-column">Название работы</div>
                      </div>`;
 
    if(enterprisesData){
      enterprisesData.forEach((item, index) => {

        fullHtml += this.drawDataInContainerOneBlock(item, fullArrayData,  allFilms);
        // listArbitorsBody.insertAdjacentHTML('beforeend', this.getElement(item, index))
      });
      listPointsBody.innerHTML = fullHtml + '</div>';
    } else 
      listPointsBody.innerHTML = 'Данных нет!';

  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
